import * as React from "react";
import styled from "styled-components";

import { Gauge } from "../../..";
import { useMarketResearchContext } from "../_infra/marketResearchProvider";
import { MarketResearchError } from "../shared/marketResearchError";
import { DiversitySkeleton } from "./diversitySkeleton";
import { DiversitySection } from "./diversitySection";

export const DiversitySectionContainer = styled.div`
    margin-bottom: 96px;
`;

export const DiversitySectionMobileContainer = styled.div`
    margin-bottom: 24px;
`;

export const DiversitySectionHeader = styled.div`
    display: grid;
    grid-template-columns: 3fr 2fr;
    margin-bottom: 80px;
`;

export const DiversitySectionHeaderMobile = styled.div``;

export const DiversitySectionHeaderLabel = styled.div`
    margin-bottom: 32px;
`;

export const DiversityMobile = styled.div``;

export const DiversityGridLabel = styled.div`
    align-self: center;
    padding-right: 16px;
    width: 168px;
    text-align: end;
`;

export const DiversityGridBars = styled.div`
    flex: 1;
    border-left: 1px solid #e8e8e8;
    padding-top: 8px;
    padding-bottom: 8px;
`;

export const DiversityGridItem = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: start;
`;

export const DiversityGridLegend = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: start;
    margin-left: 32px;
    margin-bottom: 16px;
`;

export const MarketResearchDiversity = () => {
    const {
        diversity: {
            error: diversityError,
            data: diversityData,
            isBusy: diversityIsBusy,
        },
    } = useMarketResearchContext();

    if (!!diversityError) {
        return <MarketResearchError title="diversity" error={diversityError} />;
    }

    if (diversityIsBusy || !diversityData) {
        return <DiversitySkeleton />;
    }

    return (
        <div style={{ flexGrow: 1 }}>
            <DiversitySection
                key="racial diversity"
                title="racial diversity"
                name="Racial diversity"
                statePercent={
                    diversityData.ethnicityDiversity.statePercent
                        .nonWhitePercent
                }
                regionalPercent={
                    diversityData.ethnicityDiversity.regionalPercent
                        .nonWhitePercent
                }
                isLocationRemote={diversityData.overview.isRemote}
                normalizedLocationName={
                    diversityData.overview.normalizedLocationName
                }
                metrics={diversityData.demographics}
                metricName="non-white"
                graphTitle="workforce by race"
                gauge={
                    <Gauge
                        id="racial-diversity-gauge"
                        label="Non-white workforce"
                        nationalPercent={
                            diversityData.ethnicityDiversity.statePercent
                                .nonWhitePercent
                        }
                        regionalPercent={
                            diversityData.ethnicityDiversity.regionalPercent
                                .nonWhitePercent
                        }
                    />
                }
                stateName={diversityData.overview.normalizedStateName}
            />
            <DiversitySection
                key="gender diversity"
                title="gender diversity"
                name="Gender diversity"
                statePercent={
                    diversityData.genderDiversity.statePercent.femalePercent
                }
                regionalPercent={
                    diversityData.genderDiversity.regionalPercent.femalePercent
                }
                isLocationRemote={diversityData.overview.isRemote}
                normalizedLocationName={
                    diversityData.overview.normalizedLocationName
                }
                metrics={diversityData.genders}
                metricName="female"
                graphTitle="workforce by gender"
                gauge={
                    <Gauge
                        id="gender-diversity-gauge"
                        label="Female workforce"
                        nationalPercent={
                            diversityData.genderDiversity.statePercent
                                .femalePercent
                        }
                        regionalPercent={
                            diversityData.genderDiversity.regionalPercent
                                .femalePercent
                        }
                    />
                }
                stateName={diversityData.overview.normalizedStateName}
            />
        </div>
    );
};
